import { lazy } from "react";

import type { NavigationRoutingObject } from "@navigationRouting/types";

import { hasDatasharesPermissions } from "@services/useDatasharesPermissions";

import type { I18nT } from "@lib/dashboardI18n";
import { isDeltashareAvailable } from "@lib/datashares/isDeltashareAvailable";

const DatabricksDeltashareCreateForNro = lazy(() =>
  import("@scenes/DatasharesIntegration/DatabricksDeltashareCreateForNro").then((module) => ({
    default: module.DatabricksDeltashareCreateForNro,
  }))
);

export const databricksDeltashareCreateNRO: NavigationRoutingObject = {
  Component: DatabricksDeltashareCreateForNro,
  componentFeatureFlippers: ["datashares_integrations", "datashares_integration_nro_component"],
  section: "partner-integrations",
  heading: (t: I18nT<"dashboard-navigation">) =>
    t("datashares-create-tab-databricks-heading", "Create Databricks Deltashare"),
  pageNameForTracking: () => "Create Databricks Deltashare",
  icon: "nav-system-data-sharing",
  getDeveloperNavigationAllowed: ({ featureOn, hasPermission }) => {
    return (
      featureOn("datashares_integrations") &&
      isDeltashareAvailable(featureOn) &&
      hasDatasharesPermissions({ hasPermission }).canEditDatashares
    );
  },
  additionalSearchTerms: () => [],
  additionalSearchableFeatures: () => ({}),
  defaultRoute: "/integrations/datashares_integrations/:appGroupId",
};
